import axios from "axios";

// ✅ Base API URL
const API_BASE_URL = "https://pranafreshharvest.com/api";

// ✅ Get token from localStorage
const getAuthToken = () => localStorage.getItem("token");

// ✅ Create Axios instance
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ Attach token automatically to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ POST Request (supporting custom config like multipart/form-data)
export const postRequest = async (endpoint, data, config = {}) => {
  try {
    const response = await axiosInstance.post(endpoint, data, config);
    return response.data;
  } catch (error) {
    console.error("POST Error:", error);
    throw new Error(error?.response?.data?.message || "Something went wrong");
  }
};

// ✅ GET Request
export const getRequest = async (endpoint) => {
  try {
    const response = await axiosInstance.get(endpoint);
    return response.data;
  } catch (error) {
    console.error("GET Error:", error);
    throw new Error(error?.response?.data?.message || "Something went wrong");
  }
};

// ✅ PUT Request (also supports file/form-data)
export const putRequest = async (endpoint, data, config = {}) => {
  try {
    const response = await axiosInstance.put(endpoint, data, config);
    return response.data;
  } catch (error) {
    console.error("PUT Error:", error);
    throw new Error(error?.response?.data?.message || "Something went wrong");
  }
};

// ✅ DELETE Request
export const deleteRequest = async (endpoint) => {
  try {
    const response = await axiosInstance.delete(endpoint);
    return response.data;
  } catch (error) {
    console.error("DELETE Error:", error);
    throw new Error(error?.response?.data?.message || "Something went wrong");
  }
};
